/**
 * Algomed marka sabitleri. Bot mesajlarında ve WebApp'te aynı görsel dil için.
 * Kaynak: frontend/src/theme/colors.js (brandPalette)
 */

export const BRAND = {
  name: 'Algomed',
  primary: '#4DA8FF',
  primaryHover: '#3D97E6',
  primaryDark: '#2D86CC',
  accentLight: '#73C5FF',
  accentXLight: '#C3E4FF',
  emojiBrand: '⚕',
  emojiPlan: {
    free: '○',
    silver: '◐',
    gold: '◑',
    diamond: '◆',
  },
  emojiContent: {
    question: '◇',
    flashcard: '▣',
    algospot: '✦',
    lecture: '☰',
    srs: '⟳',
    topic: '☷',
  },
  /**
   * Algomed web (frontend/src/i18n/locales/tr.json) ile birebir aynı resmi metinler.
   * Bot UI'ında ortak kopyaları tek noktadan tutmak için.
   */
  copy: {
    upgrade: 'Planı Yükselt',
    limitReachedTitle: 'Günlük Limit Doldu',
    linkCta: 'Hesabını Bağla',
    showAnswer: 'Cevabı Göster',
    submitAnswer: 'Cevabı Gönder',
    nextQuestion: 'Sonraki Soru',
    explanation: 'Açıklama',
    correct: 'Doğru',
    wrong: 'Yanlış',
    remembered: 'İyi Hatırladım',
    needReview: 'Tekrar Etmem Gerek',
    examType: 'Sınav Türü',
    branch: 'Branş',
    topic: 'Konu',
    subtopic: 'Alt Konu',
    selectScope: 'Kapsamı Belirleyin',
    clearFilters: 'Filtreleri Temizle',
  },
  /**
   * Algomed web menülerinde geçen modül adları. tr.json `nav` ve `palette.actions`
   * bloklarıyla birebir hizalı.
   */
  menuLabels: {
    home: 'Ana Sayfa',
    solve: 'Soru Çöz',
    flashcards: 'Flash Kartlar',
    flashcardDeck: 'Hafıza Kartları',
    algospot: 'AlgoSPOT',
    algospotNotes: 'AlgoSPOT Notları',
    lecture: 'Konu Anlatımı',
    topicUniverse: 'Konu Evreni',
    digitalCoach: 'Dijital Antrenör',
    digitalMentor: 'Dijital Mentor',
    mentor: 'Mentör',
    questionBank: 'Soru Bankası',
    agenda: 'Ajanda',
    store: 'Mağaza',
    account: 'Hesabım',
    notifications: 'Bildirimler',
    feedback: 'Geri Bildirim',
    preferences: 'Tercihler',
    subscription: 'Aboneliğim',
    access: 'Erişimlerim',
  },
} as const;

/**
 * Bot UI'ında tüm emoji yerine kullanılan tutarlı Unicode glyph seti.
 * Tek aile, dolgun/geometrik, anlam karışmaz. Telegram'da düz metin olarak render olur.
 */
export const ICON = {
  brand:    '⚕',   // medical caduceus
  question: '◇',   // hollow diamond
  flashcard:'▣',   // square w dot
  algospot: '✦',   // 4-point star
  lecture:  '☰',   // horizontal bars
  topic:    '☷',   // trigram
  srs:      '⟳',   // refresh arrow
  trainer:  '◉',   // target
  mentor:   '◍',   // bullseye dotted
  filter:   '⊙',   // circled dot
  home:     '⌂',   // house
  back:     '‹',
  forward:  '›',
  payment:  '◈',
  link:     '∞',
  ok:       '✓',
  cross:    '✗',
  warn:     '⚠',
  lock:     '⊘',
  plus:     '＋',
  minus:    '−',
  star:     '★',
  bullet:   '•',
  arrowR:   '→',
  scope:    '◧',   // half-filled square (filtered)
  noscope:  '□',
} as const;

export type Tier = 'free' | 'silver' | 'gold' | 'diamond';
